import { useEffect } from 'react';
import { groupUrl }  from 'utils/constants'
import { 
    updateInfoType,
    userInfoType 
}                    from 'types';


const useGetStudentScores = (
    guest:           boolean,
    dataUpdateState: updateInfoType,
    userInfo:        userInfoType,
) => {

useEffect(() => {

    if ( !groupUrl && !guest && !dataUpdateState.scores && userInfo.userEmail && !!userInfo.userEmail.length) {
      import("functions/get_data/get_student_scores").then(func => {
        func.getStudentScores('get');
    });
    }

  },[dataUpdateState, userInfo, guest])

}

export default useGetStudentScores;